import React from "react"
import { Row, Col, Container } from "react-bootstrap"

import { graphql } from "gatsby"
import { Link } from "gatsby"

import LayoutHome from "../components/layout-home"
import SEO from "../components/seo"

const IndexPage = ({ data }) => (
  <LayoutHome pageInfo={{ pageName: "Home" }}>
    <SEO title="Home" keywords={[`gatsby`, `react`, `bootstrap`]} />
    <Container className="text-center">
      <section id="about" className="about-section">
        <Row>
          <Col><br /><br /><br /><br />
            <h2>Descripción del proyecto</h2>
            <p className="text-justify">La formación de agentes de cambio implica una actividad relevante para las universidades, por lo tanto es necesario ofrecer modelos formativos que incorporen el desarrollo de competencias de emprendimiento social de manera transversal en todos los campos del conocimiento.</p>
            <p className="text-justify">En este laboratorio se abordan una serie de actividades formativas de emprendimiento social que son medidas a través de instrumentos que valoran la forma en la que los estudiantes adquieren estas competencias y con ello implementar modelos educativos interdisciplinarios y replantear la formación universitaria en este campo.</p>
          </Col>
        </Row>
        <br /><br /><br /><br />
        <Row>
          <Col>
            <Link to="proyecto/emprendimiento-social"><h2 className="text-align-center">Emprendimiento  social</h2></Link>
            <p className="text-align-center">Acción de identificar oportunidades para resolver una problemática social.</p>
          </Col>
          <Col>
            <Link to="investigacion/innovacion"><h2 className="text-align-center">Innovación </h2></Link>
            <p className="text-align-center">Adaptación para potenciar y mejorar  los aprendizajes de los estudiantes.</p>
          </Col>
          <Col>
            <Link to="proyecto/competencias"><h2 className="text-align-center">Competencia de emprendimiento social</h2></Link>
            <p className="text-align-center">Conjunto de conocimientos, habilidades y actitudes necesarios para el diseño y ejecución de
emprendimiento sociales.</p>
          </Col>
        </Row>
      </section>
    </Container>
  </LayoutHome>
)

export const query = graphql`
  query {
      fileName: file(relativePath: {eq: "demo-image-01.jpg"  }) {
      childImageSharp {
      fluid(maxWidth: 300) {
      ...GatsbyImageSharpFluid
    }
    }
  }
}
`

export default IndexPage

